import { Controller, useFormContext } from "react-hook-form";
import { Switch } from "rizzui";
import LightLandingPageTable from "../../project-landing-pages/table/table-light";
import { useParams } from "react-router-dom";
import LandingPageConfigurations from "./components/LandingPageConfigurations";
import PackageConfigurations from "./components/package/PackageConfigurations";


export interface LandingPageProps {
  isSuperAdmin?: boolean;
  name: string;
}

export default function LandingPage({ isSuperAdmin, name }: LandingPageProps) {
  const { control } = useFormContext();
  const { id } = useParams();
  return (
    <div className="grid grid-cols-1 gap-2 w-full">
      <div className="grid w-full items-start gap-32grid-cols-1">
        <h6 className="text-foreground md:text-base">Landing Page</h6>
      </div>
      <div className="grid w-full items-start gap-3 grid-cols-1">
        {isSuperAdmin && (
          <div className="flex flex-col gap-2">
            <Controller
              control={control}
              name={`${name}.enable`}
              render={({ field, fieldState, formState }) => (
                <Switch
                  label="Enable"
                  size="lg"
                  className=" w-auto"
                  {...field}
                  checked={field.value || false}
                  error={fieldState.error?.message}
                />
              )}
            />

            <LandingPageConfigurations name={name} />
          </div>
        )}
      </div>
      <PackageConfigurations name={name}/>
      <div className="w-full mt-4">
        <h6 className="text-foreground md:text-base">Agency's Landing Pages</h6>
        <LightLandingPageTable userId={id || ""} />
      </div>
    </div>
  );
}
